import { apiDataHandle } from "@/utils/api-utils";
import request from "@/utils/request";
import { SearchParam } from "./types/index";
import type { PageResult } from "@/api";

// 招标采购
export async function zbcgList(params: { category: string }) {
  const res = await request<any>(
    "/portal-site-api/notice/website/list/zbcg",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 政府采购
export async function zfcgList(params: { category: number }) {
  const res = await request<any>(
    "/portal-site-api/notice/website/list/zfcg",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 简易采购
export async function zhcgList(params: { category: string }) {
  const res = await request<any>(
    "/portal-site-api/notice/website/list/jycg",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 业绩排名
export async function yjsort(params?: any) {
  const res = await request<any>(
    "/portal-site-api/analysis/website/ranking/performance",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 提交联系方式
export async function submitContactInfo(params?: any) {
  const res = await request<any>(
    "/portal-site-api/guest-info/add",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 公告详情
export async function detailById(params: { sid: string }) {
  const res = await request<any>(
    "/portal-site-api/notice/website/detailById",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 公告详情列表
export async function listRelationById(params: { sid: string }) {
  const res = await request<any>(
    "/portal-site-api/notice/website/listRelationById",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 项目详情
export async function getProjectById(params: { sid: string }) {
  const res = await request<any>(
    "/portal-site-api/notice/website/getProjectById",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 公告检索
export async function bulletinSearch(params: SearchParam) {
  const res = await request<PageResult<any>>(
    "/portal-site-api/notice/website/page",
    "POST",
    params
  );
  return apiDataHandle<PageResult<any>>(res);
}

// 投标人数
export async function getBidderCount(params?: any) {
  const res = await request<any>(
    "/portal-site-api/analysis/website/count/bidder",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 招标人数
export async function getTenderCount(params?: any) {
  const res = await request<any>(
    "/portal-site-api/analysis/website/count/tender",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 平台项目数
export async function getProjectCount(params?: any) {
  const res = await request<any>(
    "/portal-site-api/analysis/website/count/project",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 成交总金额
export async function getAmountCount(params?: any) {
  const res = await request<any>(
    "/portal-site-api/analysis/website/count/tradingAmount",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 活跃投标人
export async function getActiveBidder(params?: any) {
  const res = await request<any>(
    "/portal-site-api/analysis/website/ranking/active-bidder",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 校验是否登录
export async function checkLogin() {
  const res = await request<any>(
    "/portal-site-api/login/website/check",
    "POST"
  );
  return apiDataHandle<any>(res);
}
// 获取用户信息
export async function queryUserInfo() {
  const res = await request<any>(
    "/portal-site-api/login/website/queryUserInfo",
    "POST"
  );
  return apiDataHandle<any>(res);
}
// 获取当前登录人菜单权限
export async function getMenuPermissionsByPath(params: any) {
  const res = await request<any>(
    "/portal-site-api/login/website/queryMenuPermissionsByPath",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
// 检验是否可以投标
export async function checkToBid(params: { sid?: string }) {
  const res = await request<any>(
    "/portal-site-api/notice/website/register/check",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}

// 政策法规、新闻、公告列表
export async function newsListPage(params: any) {
  const res = await request<any>(
    "/portal-site-api/information/website/page",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}

// 政策法规、新闻、公告列表
export async function newsDetailById(params: any) {
  const res = await request<any>(
    "/portal-site-api/information/website/detailById",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}

// 常见问题分类列表
export async function queryProblemCategoryDictList(params: any) {
  const res = await request<any>(
    "/portal-site-api/problem-category/dict/item/list",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}

// 热门搜索热词获取
export async function queryProblemotWord(params: any) {
  const res = await request<any>(
    "/portal-site-api/problem/hot/word",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}

// 常见问题卡片
export async function queryProblemCards(params: any) {
  const res = await request<any>(
    "/portal-site-api/problem/cards",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}

// 常见问题列表
export async function queryProblemList(params: any) {
  const res = await request<any>(
    "/portal-site-api/problem/list",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}

// 常见问题详情
export async function queryProblemDetail(params: any) {
  const res = await request<any>(
    "/portal-site-api/problem/getById",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}

// 用户意见反馈
export async function submitUserFeedback(params: any) {
  const res = await request<any>(
    "/portal-site-api/problem/submitUserFeedback",
    "POST",
    params
  );
  return apiDataHandle<any>(res);
}
